import React from 'react';

import Link from 'next/link';

import SectionHeader from '@/components/display/headers/SectionHeader';
import NewsletterSubscribeInput from '@/components/pages/frontpage/components/NewsletterSubscribeInput';
import NewsletterDailyPageItem from '@/components/pages/newsletter/daily/layout/NewsletterDailyPageItem';
import { BlastStruct } from '@/utils/functions/sailthru/fetchSailthruBlasts';

export type NewsletterDailyPageLayoutProps = {
    latest: BlastStruct[];
    frequency: string;
    title: string;
    description: string;
    imageUrl?: string;
    subscribeCallback(email: string): Promise<any>;
};

const NewsletterDailyPageLayout = (props: NewsletterDailyPageLayoutProps) => {
    const { latest, frequency, title, description, imageUrl, subscribeCallback } = props;

    return (
        <div className="w-full">
            <section className="mx-auto">
                <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 p-4 pt-10 pb-20">
                    <div className="flex flex-col justify-center items-start gap-10 max-w-lg">
                        <div className="flex flex-col gap-5">
                            <div className="flex flex-col relative">
                                <p className="text-xl text-left text-[#110b29]">{frequency}</p>
                                <p className="text-[40px] text-left text-[#110b29]">{title}</p>
                                <p className="text-2xl text-left text-[#5637cd] mt-3">{description}</p>
                            </div>
                            <div className="flex justify-start items-center gap-5 w-full">
                                <NewsletterSubscribeInput
                                    className="w-full"
                                    inputPlaceholder={'Enter email address'}
                                    buttonText={'Subscribe'}
                                    onButtonClick={subscribeCallback}
                                />
                            </div>
                            {latest && latest.length > 0 && (
                                <div>
                                    <Link href={`/newsletter/issue/${latest[0]!.id}`}>
                                        <a className="self-stretch flex-grow-0 flex-shrink-0 w-[524px] text-lg text-left text-[#5637cd]">
                                            View latest issue
                                        </a>
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="px-24 hidden lg:block align-left">
                        {imageUrl ? (
                            <img src={imageUrl} className="h-[589px] object-cover" />
                        ) : (
                            <img
                                src="/images/newsletter/newsletter-phone.png"
                                srcSet="/images/newsletter/newsletter-phone.png 1x, /images/newsletter/newsletter-phone@2x.png 2x, /images/newsletter/newsletter-phone@3x.png 3x"
                                className="w-[221.26px] h-[589px]"
                            />
                        )}
                    </div>
                </div>
            </section>
            {latest && (
                <>
                    <SectionHeader className="w-full border-b border-t" title="Latest" linkTitle="" />
                    <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4">
                        {latest.slice(0, 12).map(campaign => (
                            <NewsletterDailyPageItem
                                key={campaign.id}
                                id={campaign.id}
                                time={campaign.schedule_time}
                                list={campaign.list}
                                subject={campaign.subject}
                            />
                        ))}
                    </section>
                </>
            )}
        </div>
    );
};

export default NewsletterDailyPageLayout;
